module.exports = {
      id: "twitter-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#twitter-icon",
      toString: function () {
        return this.url;
      }
    }